import React from "react";
import { Form } from "react-bootstrap";
import { FieldRendererProps } from "../types";
import { CampoContainer, AjudinhaWrapperCheckbox, ErrorMessage } from "../styles";
import { TipoFormulario } from "../../../services/constantes";
import Ajudinha from "../../ajudinha";

export const CheckboxFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, errors,
}) => (
  <CampoContainer>
    <Form.Check
      type="checkbox"
      label={
        <>
          {campo.label}
          {campo.required && <span style={{ color: '#dc3545', marginLeft: '4px' }}>*</span>}
        </>
      }
      checked={!!getFieldValue(campo.nome)}
      onChange={(e) => {
        campo.onCampoDigitar && campo.onCampoDigitar(e.target.checked);
        handleInputChange(campo.nome, e.target.checked);
      }}
      required={campo.required}
      readOnly={campo.apenasLeitura || modo === TipoFormulario.tpVisualizacao}
      disabled={campo.apenasLeitura || modo === TipoFormulario.tpVisualizacao}
      style={{ marginBottom: "-10px" }}
      className="custom-checkbox"
    />
    {campo.ajudinha?.texto && (
      <AjudinhaWrapperCheckbox>
        <Ajudinha texto={campo.ajudinha.texto} autoCloseTime={campo.ajudinha.autoCloseTime} />
      </AjudinhaWrapperCheckbox>
    )}
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </CampoContainer>
);
